export enum  EnumSincronizacao {
    INCOMPLETO = 'I',
    ENVIAR = 'E',
    ENVIADO = 'O'
}
